// 导入api接口模块
import home from './home'

// 获取当前环境变量 true => 生产环境 false => 开发环境
const BASEURL = (process.env.NODE_ENV === 'production') ? '/gamemanager' : '/gamemanager'

export const api = {
  // 登录模块
  ...home(BASEURL),
  // 图片上传
  upload: `${BASEURL}/public/upload`,
  // 商家入驻
  enterpriseCheck: `${BASEURL}/check/enterpriseCheck`,
  individualCheck: `${BASEURL}/check/individualCheck`,
  organizationsCheck: `${BASEURL}/public/add`,
  personalCheck: `${BASEURL}/check/personalCheck`,
  getByName: `${BASEURL}/app/getSelect`,
  sendCode: `${BASEURL}/public/sendCode`,
  getDictData: `${BASEURL}/public/dict/data/type`,
  
//   submitDept:`${BASEURL}/system/dept/addNewDept`,
  submitDept:`${BASEURL}/public/addNewDept`,
  uploadImg:`${BASEURL}/common/createOSS`
}
export default api



// WEBPACK FOOTER //
// ./src/api/index.js